import { Text, styled } from '@/theme/index';

export const StyledText = styled(Text)(({ theme }) => ({
  fontSize: '1rem',
  maxWidth: 160,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(1),

  ':hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));
